export let dataProps = {
    id: 0,
    overtime_name: '',
    duration_minute_start_range: 0,
    duration_minute_end_range: 60,
    overtime_type: 0, //normal, weekday off overtime, holiday overtime
    in_time_late_buffer: 0,
    man_hours: 0
}


// WEBPACK FOOTER //
// ./src/store/modules/overtimeMaster/properties.js